jQuery(document).ready(function($) {

  if ( $('.m-image-slider')[0] ) {
    $('.m-image-slider__list').slick({
      dots: true,
      prevArrow:
          `<button
            class="m-image-slider__arrow m-image-slider__arrow--prev slick-prev a-expandable-arrow-button a-expandable-arrow-button--left a-expandable-arrow-button--point-left"
            type="button"
            aria-label="Previous Image"
          >
            <span class="a-expandable-arrow-button__circle">
              <span class="a-expandable-arrow-button__text">Prev</span>
              <i class="a-expandable-arrow-button__arrow"></i>
            </span>
          </button>`,
      nextArrow:
        `<button
          class="m-image-slider__arrow m-image-slider__arrow--next slick-next a-expandable-arrow-button"
          type="button"
          aria-label="Next Image"
        >
          <span class="a-expandable-arrow-button__circle">
            <span class="a-expandable-arrow-button__text">Next</span>
            <i class="a-expandable-arrow-button__arrow"></i>
          </span>
        </button>`
    });

    $(".m-image-slider .m-browser-toolbar__button--left-arrow").click(function () {
      $(this).closest(".m-image-slider__list").slick("slickPrev");
    });

    $(".m-image-slider .m-browser-toolbar__button--right-arrow").click(function () {
      $(this).closest(".m-image-slider__list").slick("slickNext");
    });
  }

});